<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import {
  required
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "User Profile",
    meta: [
      {
        name: "User Profile",
      },
    ],
  },
  components: {  },
  props:['userId','userTypeId','userName'],
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      autoClose: "",
      attendWorship: "",
      isKnowApplicant: "",
      cooperation: "",
      options: [
        "Yes",
        "No",
      ],
      preservePage: 1,
      pageLimit:10,
      status: [
        "Active",
        "InActive",
      ],
      currentUserData: JSON.parse(localStorage.getItem('user')),
      tags: null,
      hours: null,
      totalHours: '',
      hourForm: {
        user_id : this.user_id,
        comment: "",
        date: "",
        hours: "",
        minutes: "",
      },
      tagForm: {
        name: "",
      },
      searchForm: {
        tag: "",
        commenter: "",
      },
      isTag: false,
      isCommenter: false,
      isSearching: false,
      isLoading:false,
      noRecord: false,
      searchBy:'',
      isUpdate: false,
      isAdd: false,
      typeSubmit: false,
      modalTitle:'',
      commentId:'',
    }
  },
  filters: {
    moment: function (date) {
      if( date === null ) {
        return "";
      }
      return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }
  },
  validations: {
    hourForm: {
      comment: "",
      date: { required },
      hours: { required },
      minutes: { required },
    },
  },
  mounted(){
    this.getHours();
  },
  methods: {

    getHours(page) {
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined') {
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page=' + this.pageLimit
      let userId = '&user_id=' + this.userId
    //   if (this.searchForm.tag){
    //     filter += '&tag='+ this.searchForm.tag
    //   }
    //   if (this.searchForm.commenter){
    //     filter += '&commenter='+ this.searchForm.commenter
    //   }
      axios.get('admin/user/hours?pagination=true&page=' + page + filter + userId).then(res => {
        this.hours = res.data.response;
        this.calculateTotalHours();
        this.isLoading = false;
        if (!this.hours.length) {
          this.noRecord = true;
          if (page > 1) {
            this.getHours(page - 1);
          }
        }
      })
    },

    calculateTotalHours() {
        this.totalHours = '';
        let totalMinutes = 0;
        if( this.hours.length > 0 ) {
            for( var i = 0; i < this.hours.length; i++ ) {
                totalMinutes += ((parseInt(this.hours[i].hours) * 60) + parseFloat(this.hours[i].minutes));
            }
        }

        this.totalHours = Math.floor(totalMinutes / 60) + ' hours ' + (totalMinutes % 60) + ' minutes';
    },

    showEditModal(hours) {
      this.modalTitle = 'Edit Hours'
      this.$bvModal.show('hourModal');
      this.hourForm.comment = hours.comment;
      this.hourForm.date = hours.date;
      this.hourForm.hours = hours.hours;
      this.hourForm.minutes = hours.minutes;
      this.hourForm.user_id = this.userId;
      this.hourId = hours.id;
      this.isUpdate = true;
      this.isAdd = false;
    },

    showAddModal() {
      this.typeSubmit = false;
      this.modalTitle = 'Add Hours'
      this.$bvModal.show('hourModal');
      this.isAdd = true;
      this.isUpdate = false;
      this.commentForm = {
        date: "",
        hours: "",
        minutes: "",
        comment: "",
      };
    },

    updateHours() {
      this.typesubmit = true;
      this.$v.$touch();
      if (!this.$v.hourForm.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.patch('admin/user/hours/'+this.hourId, this.hourForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Success!",
                    text:"Hours updated successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getHours();
                  this.typeSubmit = false;
                  this.$bvModal.hide('hourModal');
                  this.hourForm = {
                    date: "",
                      hours: "",
                      minutes: "",
                    comment: "",
                  };
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      }

    },

    deleteHours(hourId) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes, delete it!"
          }).then(result => {
            if (result.value) {
              console.log(hourId);
              axios.delete('admin/user/hours/'+hourId, config)
                  .then((res) => {
                    if (res.status == '200'){
                      Swal.fire({
                        title: "Deleted!",
                        text:"Hours have been deleted!",
                        icon: "success",
                        width: 350,
                        showConfirmButton: false,
                        timer: 1500
                      });
                      this.getHours();
                    }
                  })
                  .catch((err) => {
                    if (err.response) {
                      Swal.fire({
                        title: "Error!",
                        text: err.response.data.error.message,
                        icon: "danger",
                        width: 350,
                        showConfirmButton: true
                      });
                    }
                  })
            }
          });
        }

    },

    addHours() {
      this.typeSubmit = true;
      this.$v.$touch();
      if (!this.$v.hourForm.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          this.hourForm.user_id = this.userId;
          axios.post('admin/user/hours', this.hourForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Success!",
                    text:"Hours added successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.$bvModal.hide('hourModal');
                  this.hourForm = {
                      date: "",
                      hours: "",
                      minutes: "",
                    comment: "",
                  };
                  this.typeSubmit = false;
                  this.getHours();
                }
              })
              .catch((err) => {
                if (err.response.data.error.custom_code == '401'){
                    console.log(err.response.data.error)
                }
                if (err.response) {
                  console.log(err.response.data.error)
                }
              })
        }
      }

    },

    searchOption(event){
      this.searchForm = {
        tag: "",
        commenter: "",
      };
      let selectedValue = event.target.value
      if (selectedValue == ''){
        this.resetSearch();
      }
      if (selectedValue == 'tag') {
        this.isTag = true;
        this.isCommenter = false;
        this.isSearching = true;
      }
      if (selectedValue == 'commenter') {
        this.isTag = false;
        this.isCommenter = true;
        this.isSearching = true;
      }
    },

    searchComments(){
      this.getComments();
    },

    resetSearch(){
      this.searchForm = {
        tag: "",
        commenter: "",
      };
      this.isSearching = false;
      this.isTag = false;
      this.isCommenter = false;
      this.searchBy ='';
      this.getComments();
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex">

      <div class="mb-4 mdl-btns ms-auto">

        <!--Add New Comment Modal-->
        <b-button @click="showAddModal" variant="primary">Add Hours</b-button>
        <b-modal
            id="hourModal"
            centered
            :title="modalTitle"
            title-class="font-18"
            hide-footer
        >
          <form >

            <div class="mb-3">
              <label>Select Date</label>
              <div>
                  <input type="date" v-model="hourForm.date" class="form-control" :class="{
                    'is-invalid': typeSubmit && $v.hourForm.comment.$error,
                  }">
                <div
                    v-if="typeSubmit && $v.hourForm.date.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.hourForm.date.required"
                  >Date is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="mb-3">
                <div class="row">
                    <div class="col-6">
                        <label>Hours</label>
                        <div>
                            <input type="number" v-model="hourForm.hours" class="form-control" :class="{
                                'is-invalid': typeSubmit && $v.hourForm.hours.$error,
                            }">
                            <div
                                v-if="typeSubmit && $v.hourForm.hours.$error"
                                class="invalid-feedback"
                            >
                            <span v-if="!$v.hourForm.hours.required"
                            >Hours are required.</span
                            >
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <label>Minutes</label>
                        <div>
                            <!-- <input type="number" v-model="hourForm.minutes" class="form-control" :class="{
                                'is-invalid': typeSubmit && $v.hourForm.minutes.$error,
                            }"> -->
                            <select
                                class="form-select custom-select" v-model="hourForm.minutes" :class="{
                                'is-invalid': typeSubmit && $v.hourForm.minutes.$error,
                            }">
                              <option value="0">0 mins</option>
                              <option value="15">15 mins</option>
                              <option value="30">30 mins</option>
                              <option value="45">45 mins</option>
                            </select>
                            <div
                                v-if="typeSubmit && $v.hourForm.minutes.$error"
                                class="invalid-feedback"
                            >
                            <span v-if="!$v.hourForm.minutes.required"
                            >Hours are required.</span
                            >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3">
              <label>Comment</label>
              <div>
                  <textarea v-model="hourForm.comment"
                      class="form-control"
                      name="comment"
                      rows="3" placeholder="Enter Comment"
                            :class="{
                    'is-invalid': typeSubmit && $v.hourForm.comment.$error,
                  }"
                  ></textarea>
                <div
                    v-if="typeSubmit && $v.hourForm.comment.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.hourForm.comment.required"
                  >Comment is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="mb-0">
              <div>
                <button type="button" v-if="isAdd" @click="addHours" class="btn btn-primary">Add Hours</button>
                <button type="button" v-if="isUpdate" @click="updateHours" class="btn btn-primary">Update Hours</button>
              </div>
            </div>

          </form>
        </b-modal>

      </div>

    </div>

    <!-- <form class="row align-items-center form-inline mb-4 border p-3 m-0">
      <div class="col-md-12">
        <h4 class="font-size-14">Search By:</h4>
      </div>
      <div class="col-md-4">
        <select
            class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
          <option value="">Select Option</option>
          <option value="tag">Tag</option>
          <option value="commenter">Commenter</option>
        </select>
      </div>
      <div class="col-md-2 sm-hidden xs-hidden"></div>
      <div class="col-md-6 pull-right">
        <div class="row app-search pt-0 pb-0">

          <div class="col-md-12 d-flex">
            <input v-if="isTag"
                   v-model="searchForm.tag"
                   type="text"
                   class="ps-4 form-control"
                   placeholder="Type Tag"
            />
            <input v-if="isCommenter"
                   v-model="searchForm.commenter"
                   type="text"
                   class="ps-4 form-control"
                   placeholder="Type Commenter Name"
            />

            <b-button v-if="isSearching" id="show-btn" class="btn-find" @click="searchComments" variant="primary" title="Search">
              <i class="bx bx-search-alt-2"> Search</i>
            </b-button>

            <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                      variant="primary" title="Reset">
              <i class="bx bx-reset"> Reset</i>
            </b-button>
          </div>
        </div>
      </div>
    </form> -->

    <div class="row mt-3">

      <div class="col-md-12 px-0 cards-cont">

        <div v-if="this.hours">
            <div class="table-responsive ">
                  <table class="table table-bordered table-hover table-striped align-middle mb-0">
                    <tbody>
                    <tr v-if="noRecord">
                      <td colspan="4" class="p-0">
                        <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
                      </td>
                    </tr>

                    <tr v-if="isLoading">
                      <td colspan="4" class="text-center p-0">
                        <b-spinner
                            class="m-2"
                            variant="primary"
                            role="status"
                        ></b-spinner>
                      </td>
                    </tr>

                    <tr v-else v-for="(hour, index) in this.hours" :key="index">
                      <td>
                        {{hour.date | moment}}
                      </td>
                      <td>
                        {{hour.hours}} hours {{hour.minutes}} minutes
                      </td>
                      <td>
                        <p class="text-muted mb-0 text-wrap">
                          {{hour.comment}}
                        </p>
                      </td>
                      <td style="position:relative">
                        <p class="text-muted mb-0 icons-wrap">
                          <a href="javascript:;" @click="showEditModal(hour)"  class="text-dark"><i class="bx bxs-pencil"></i></a>
                            <a href="javascript:;" @click="deleteHours(hour.id)" class="ms-1 text-dark"><i class="bx bx-x font-size-24"></i></a>
                        </p>
                      </td>

                    </tr>

                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total Hours</th>
                            <th>{{this.totalHours}}</th>
                            <th colspan="2"></th>
                        </tr>
                    </tfoot>
                  </table>
                </div>
        <!-- <b-card class="border border-2 shadow-none" v-for="(hour,index) in this.hours"
          :key="index"
        >
          <h5 slot="header" class="mb-0">{{userName}}

            <p class="font-size-13 mb-0 ms-5 fw-bold d-inline-block">
              {{new Date(hour.created_at).toLocaleString()}}
            </p>

            <p class="mb-0 float-end icons-wrap">
              <a href="javascript:;" @click="showEditModal(hour)"  class="text-dark"><i class="bx bxs-pencil"></i></a>
              <a href="javascript:;" @click="deleteComment(hour.id)" class="ms-1 text-dark"><i class="bx bx-x font-size-24"></i></a>
            </p>

          </h5>
        </b-card> -->
        </div>

      </div>
    </div>
  </div>
</template>
<style scoped>
.mdl-btns button:nth-child(1){
  margin-right:1rem;
}
.icons-wrap{
  position:absolute;
  top:7px;
  right:10px;
  display:flex;
}
.icons-wrap a:first-child{
  margin-top: 4px;
}
.cards-cont .card:nth-child(odd) .card-header{
  background-color: #32b1f9;
}
.app-search input, .app-search select{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.app-search .btn-find{
  width: 40%;
  border-top-right-radius:30px;
  border-bottom-right-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow:none;
}
.app-search .btn-reset{
  width: 40%;
  font-size: 15px;
  box-shadow:none;
  border-radius:30px;
}
</style>
